// Editable table of extracted + manually added items. Sources its own
// state from a parent-supplied array; mutations call back up so the
// parent (ProjectDetail) stays the source of truth.
import type { TakeoffItemDto } from "../../../../../shared/types/pipe-takeoff";
import { ItemRow } from "./ItemRow";
import { ItemAddForm } from "./ItemAddForm";

interface Props {
  projectId: number;
  items: TakeoffItemDto[];
  onChanged: (next: TakeoffItemDto) => void;
  onAdded: (item: TakeoffItemDto) => void;
  onDeleted: (id: number) => void;
}

export function ItemsTable({ projectId, items, onChanged, onAdded, onDeleted }: Props) {
  return (
    <div style={{ display: "grid", gap: 12 }}>
      <ItemAddForm projectId={projectId} onAdded={onAdded} />

      {items.length === 0 ? (
        <p style={{ color: "var(--bsp-fg-muted)", margin: 0 }}>
          No items yet. Add one above, or run extraction from the project page.
        </p>
      ) : (
        <div className="bsp-card" style={{ padding: 0 }}>
          <table className="bsp-table">
            <thead>
              <tr>
                <th style={{ width: 24 }} />
                <th>Category</th>
                <th>Description</th>
                <th>Size</th>
                <th>Material</th>
                <th>Qty</th>
                <th>Length (m)</th>
                <th>Section</th>
                <th style={{ width: 80 }} />
              </tr>
            </thead>
            <tbody>
              {items.map((it) => (
                <ItemRow
                  key={it.id}
                  projectId={projectId}
                  item={it}
                  onChanged={onChanged}
                  onDeleted={onDeleted}
                />
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
